<template>
  <div class="container">
    <div class="row mt-lg-n10 mt-md-n11 mt-n10 justify-content-center">
      <div class="mx-auto col-xl-4 col-lg-5 col-md-7">
        <div class="card z-index-0 mt-10">
          <div class="card-body">
            <soft-badge
              color="warning"
              variant="gradient"
              size="sm"
              @click="$emit('close-edit-course')"
              class="cursor-pointer float-right"
            >
              {{ $t("global.close") }}
            </soft-badge>
            <p class="my-3 text-bold">
              {{ $t("courses.editingCourse") }}
            </p>

            <form @submit.prevent="submitForm">
              <div class="mb-3">
                <span class="text-xs text-secondary mb-0">{{
                  $t("courses.title")
                }}</span>
                <InputForm
                  v-model="formData.title"
                  :placeholder="localCourse.title"
                  type="text"
                />
              </div>
              <div class="text-center">
                <soft-button
                  color="dark"
                  full-width
                  variant="gradient"
                  class="my-4 mb-2"
                >
                  {{ $t("global.edit") }}
                </soft-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import InputForm from "@/components/InputForm.vue";
//import SelectFormCourse from "@/components/SelectFormCourse.vue";
import SoftButton from "@/components/SoftButton.vue";
import SoftBadge from "@/components/SoftBadge.vue";
//import DatePicker from "@/components/DatePicker.vue";
import swal from "sweetalert2";

export default {
  name: "FormCreateTeacher",
  components: {
    InputForm,
    //SelectFormCourse,
    SoftButton,
    SoftBadge,
    //DatePicker,
  },
  props: {
    course: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      formData: {
        id: null,
        title: "",
      },
      curse: {},
      localCourse: { ...this.course },
    };
  },
  methods: {
    async submitForm(event) {
      event.preventDefault();
      const formData = new FormData();
      formData.append("_method", "PATCH");
      formData.append("id", this.localCourse.id);
      if (this.formData.title != "") {
        formData.append("title", this.formData.title);
      }
      try {
        await axios.post("course/" + this.localCourse.id, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        this.resetForm();
        this.$emit("close-edit-course");
        swal.fire({
          icon: "success",
          title: "Kurs uspesno azuriran",
          showConfirmButton: false,
          timer: 2000,
        });
      } catch (error) {
        if (error.response && error.response.status === 422) {
          const errors = error.response.data.errors;
          let errorMessages = "";

          if (typeof errors === "function") {
            for (const key in errors) {
              if (errors.prototype.hasOwnProperty.call(errors, key)) {
                errorMessages += `- ${errors[key].join(", ")}\n`;
                swal.fire({
                  title: this.$t("global.error"),
                  html: errorMessages.replace(/\n/g, "<br>"),
                  icon: "error",
                  position: "top-end",
                });
              }
            }
          } else {
            for (const key in errors) {
              errorMessages += `- ${errors[key].join(", ")}\n`;
              swal.fire({
                title: this.$t("global.error"),
                html: errorMessages.replace(/\n/g, "<br>"),
                icon: "error",
                position: "top-end",
              });
            }
          }
        }
      }
    },
    getCourse(selectedCourse) {
      this.formData.course_id = selectedCourse;
    },
    resetForm() {
      this.formData.title = "";
      return;
    },
  },
  watch: {
    course(newCourse) {
      this.localCourse = { ...newCourse };
    },
  },
};
</script>

<style scoped>
.custom-file-upload {
  display: inline-block;
  padding: 10px 20px;
  cursor: pointer;
  background: linear-gradient(to right, #7fe02f, #2cb735);
  color: white;
  border-radius: 8px;
}
#file {
  display: none;
}
.custom-file-upload span {
  pointer-events: none;
}
.float-right {
  float: right;
}
</style>
